import { useMutation } from '@apollo/client';
import DefaultModal from 'components/common/DefaultModal';
import FilterBar from 'components/common/FilterBar';
import IconComponent from 'components/common/IconComponent';
import { InputComponent } from 'components/common/Input';
import { INPUT_TYPE } from 'components/common/Input/types';
import LocationSelectForm from 'components/common/LocationSelectForm';
import { ERRORS } from 'constants/notify';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { FilterContainerStyled } from 'routes/Appointments/components/AppointmentFilterBars/styled';
import { UPDATE_USER } from 'services/graphql/mutations/users';
import { ILocation } from 'types/location';
import { RoleEnum } from 'types/user';
import { defaultNotification, getNewQueryString } from 'utils';

import { useFilterData } from './hooks';
// import { IMultipleFilterOptionsProps } from 'routes/Users/components/UsersList/types';

const Filter: React.FC<{ locations?: ILocation[] }> = ({ locations }) => {
  const history = useHistory();
  const queries = useQueryParamsAsKeyValuePair();
  const { mainLocation: userMainLocation, role, id: userId } = useCurrentLoggedInUser();
  const [filter, setFilter] = useState({
    onlyMine: queries?.onlyMine,
    location: queries?.location || userMainLocation?.id,
  });
  const [locationModalVisibility, setLocationModalVisibility] = useState(false);
  const isCurrentUserClient = role === RoleEnum.CLIENT;
  const { withoutNotaryFilterBarOptions } = useFilterData('transaction', locations);

  const onChangeOwnershipOption = (v: boolean) => {
    const queryString = getNewQueryString(history.location.search, { onlyMine: v || undefined, page: undefined });
    history.push({ pathname: history.location.pathname, search: queryString });
    setFilter((c) => ({ ...c, onlyMine: v }));
  };

  const onClickLocationIcon = () => {
    setLocationModalVisibility(true);
  };

  const closeLocationModal = () => {
    setLocationModalVisibility(false);
  };

  const [updateUser, { loading: updateUserLoading }] = useMutation(UPDATE_USER);

  const onSelectLocationFromModal = async (location: ILocation) => {
    try {
      await updateUser({
        variables: {
          filter: { id: userId },
          updatedDoc: {
            mainLocation: location.id,
          },
        },
      });
      // const updatedData = updatedDataFromMutation?.data.updateUserEntity;
      // if (updatedData) dispatch(UserAction.fetchUserSuccess({ mainLocation: updatedData.mainLocation }));
      defaultNotification({ success: 'Update Main Location Successfully!' });
      closeLocationModal();
      // refetch();
    } catch (err) {
      defaultNotification({ failure: ERRORS.DEFAULT_MUTATION_ERROR });
    }
  };

  return (
    <>
      {!isCurrentUserClient ? (
        <FilterContainerStyled style={{ width: 300, maxWidth: '33%' }}>
          <FilterBar
            options={withoutNotaryFilterBarOptions}
            notSpecifiedValueLabel='By Notary Assignments: All'
            name='withoutNotary'
          />
        </FilterContainerStyled>
      ) : (
        <>
          <DefaultModal
            props={{
              visible: locationModalVisibility,
              onCancel: closeLocationModal,
              title: 'Set Current Office Location',
            }}>
            <LocationSelectForm
              locations={locations}
              onLocationSelect={onSelectLocationFromModal}
              loading={updateUserLoading}
            />
          </DefaultModal>
          <div className='flex flex-col sm:flex-row items-center radio-transactions-by-ownership'>
            <div className='order-2 sm:order-1'>
              <InputComponent
                type={INPUT_TYPE.RADIO}
                onChange={onChangeOwnershipOption}
                style={{ marginBottom: -6 }}
                name='onlyMine'
                label=''
                value={filter.onlyMine || false}
                inputSettings={{ radioStyle: 'tab' }}
                inputOptions={[
                  { value: true, label: 'My Transactions' },
                  { value: false, label: 'All Transactions' },
                ]}
              />
            </div>
            <div className='order-1 sm:order-2 sm:ml-8 sm:mb-0 mb-4'>
              <div className='text-xs font-bold'>Office Location:</div>
              <div className='flex text-base items-center'>
                <div>{userMainLocation?.name}</div>
                <div className='ml-1 cursor-pointer' onClick={onClickLocationIcon}>
                  <IconComponent name='chevron-right' color='#038fde' size={14} />
                </div>
              </div>
            </div>
            {/* <FilterContainerStyled className='mt-0' style={{ width: 300, maxWidth: '33%' }}>
            <FilterBar options={ownerShipFilterBarOptions} notSpecifiedValueLabel='By Ownership: All' name='onlyMine' />
          </FilterContainerStyled>
          <FilterContainerStyled className='mt-4 sm:mt-0 sm:ml-4' style={{ width: 300, maxWidth: '33%' }}>
            <FilterBar
              options={locationFilterBarOptions}
              notSpecifiedValueLabel='By Locations: All'
              name='locationIds'
            />
          </FilterContainerStyled> */}
          </div>
        </>
      )}
    </>
  );
};

export default React.memo(Filter);
